module.exports = __webpack_public_path__ + "warm-3gAotT1.svg";